import LayoutFactory from './LayoutFactory';

export default LayoutFactory;
